import { dateFormatters } from '@/utils/date-util'
import { match } from '@/utils/pattern-match-util'
import type { PersonalInfo } from '@/features/jobs/info-gathering/individual-info/PersonalInfo'
import type { TaxRefundDeliveryMethodType } from '@/features/jobs/info-gathering/tax-refund-method/TaxRefundDeliveryMethod'

/**
 * Formats a person's full name.
 */
export function formatFullName(info: PersonalInfo) {
  return [info.firstName, info.middleInitial, info.lastName]
    .filter(Boolean)
    .join(' ')
}

/**
 * Formats a date captured on a profile, such as a date of birth.
 */
export function formatProfileDate(date: Date | null) {
  return date ? dateFormatters.dateAmerican.format(date) : ''
}

/**
 * Masks all but the last 4 digits of an SSN or ITIN.
 */
export function maskPersonalTaxpayerIdentificationNumber(value: string) {
  return value.replace(/\d{3}-\d{2}-(\d{4})/, '✶✶✶-✶✶-$1')
}

/**
 * Masks all but the last 3 digits of an EIN.
 */
export function maskEmployerIdentificationNumber(value: string) {
  return value.replace(/\d{2}-.*(\d{3})$/, '✶✶-✶✶✶✶$1')
}

/**
 * Masks every digit of an account or routing number.
 */
export function maskDigits(value: string) {
  return value.replace(/\d/g, '*')
}

/**
 * Masks every non-whitespace character.
 */
export function maskText(value: string) {
  return value.replace(/\S/g, '*')
}

/**
 * Formats a tax refund delivery method type for display.
 */
export function formatTaxRefundDeliveryMethodType(
  type: TaxRefundDeliveryMethodType,
) {
  return match(type, {
    Check: 'Check',
    DirectDeposit: 'Direct deposit',
    FutureTaxCredit: 'Future tax credit',
  })
}
